<template>
  <b-container>
    <b-row>
      <b-col sm="4" style="position: relative; line-height: 0.7rem">
        <b-button-group style="width: 60%">
          <b-button
            class="mb-1"
            style="padding: 0; width: 50%"
            :variant="is_pub ? 'outline-secondary' : 'vxon'"
            @click="publicSet(false)"
          >
            Private
          </b-button>
          <b-button
            class="mb-1"
            style="padding: 0; width: 50%"
            :variant="is_pub ? 'danger' : 'outline-secondary'"
            @click="publicSet(true)"
          >
            Public
          </b-button>
        </b-button-group>
        <div v-if="is_pub" style="font-size: 0.7rem">
          This event will show on the public event list.
        </div>
      </b-col>
      <b-col> </b-col>
      <b-col v-if="$parent.event.full_admin">
        <b-button
          size="sm"
          class="float-right"
          v-on:click="delete_event"
          variant="danger"
        >
          Delete Event
        </b-button>
      </b-col>
    </b-row>

    <b-row class="row">
      <b-col>
        <label>Name of the Event</label>
        <b-form-input
          v-model="$parent.event.name"
          maxlength="150"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="row" align-v="center">
      <b-col cols="1">
        <label>Starts:</label>
      </b-col>
      <b-col cols="4">
        <date-picker
          placeholder="Start time"
          v-model="startdate"
          type="datetime"
          :clearable="false"
          :not-before="Date.now()"
          lang="en"
          format="MM-DD-YYYY [at] hh:mm A"
          :time-picker-options="{
            start: '00:00',
            step: '00:15',
            end: '23:59',
          }"
        ></date-picker>
      </b-col>
      <b-col cols="1">
        <label>Ends:</label>
      </b-col>
      <b-col cols="4">
        <date-picker
          placeholder="End time"
          v-model="enddate"
          type="datetime"
          :clearable="false"
          :not-before="Math.max(startdate, Date.now())"
          :input-attr="{ required: true }"
          lang="en"
          format="MM-DD-YYYY [at] hh:mm A"
          :time-picker-options="{
            start: '00:00',
            step: '00:15',
            end: '23:59',
          }"
        ></date-picker>
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col>
        <label>Describe the event</label>
        <b-form-textarea
          class="para"
          v-model="$parent.event.descr"
          rows="5"
          maxlength="600"
        >
        </b-form-textarea>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b>Event Banner</b>
        <upload-image
          v-model="$parent.event.banner"
          :evid="$parent.event.id"
          imgkind="banner"
          size="2"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b>Event Logo (Optional)</b>
        <upload-image
          v-model="$parent.event.logo"
          :evid="$parent.event.id"
          imgkind="logo"
          optional="true"
          size="0.004"
        />
      </b-col>
    </b-row>

    <b-row v-if="$parent.event.full_admin">
      <b-col>
        <b-form-group
          label="Event coordinators (Optional)"
          style="font-weight: 600"
          label-for="tags-coord"
        >
          <b-form-tags
            input-id="tags-coord"
            v-model="coord_list"
            no-outer-focus
            :input-attrs="{ 'aria-describedby': 'coord-validation-help' }"
            :tag-validator="coord_validator"
            invalid-tag-text="Invalid email address"
            placeholder="Email addresses..."
          >
          </b-form-tags>
          <template v-slot:description>
            <div id="coord-validation-help">
              The email addresses of users permitted to edit and manage this
              event.
            </div>
          </template>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      ><b-col>
        <b-button
          v-bind:disabled="isSubmitDisabled"
          size="sm"
          v-on:click="update"
          variant="primary"
        >
          Submit Event
        </b-button>
      </b-col></b-row
    >
  </b-container>
</template>
<script>
import { sync } from "vuex-pathify";
import DatePicker from "vue2-datepicker";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";
import UploadImage from "../components/UploadImage";

export default {
  name: "update_event",
  data() {
    return {
      
    //  tkt_enable:false, 
    //  Active:true, 
     groupFields: [
       {key: "dname", label: ""},
       {key: "ctrl", label: ""},
     ],
     tier_name: "",
     no_file_error: false,
     file_error: false,
     event_upload_pending: false,
     event_upload_success: false,
     event_upload_error: false,
     isSubmitDisabled: false,
     is_pub: false,
     startdate: new Date(),
     enddate: new Date(),
     coord_list: [],
    //  tkt:{name:"", groups:[], price:"", type:"", status:""},
    //  tkts:[],
     edit_modal_title: "Edit",
    //  ticketFields: [
    //       {key: "ctrl", label: ""},
    //       {key: "name", label: "Ticket Name"},
    //       {key: "type", label: "Ticket Type"},
    //       {key: "groups", label: "Groups assigned", formatter: value => {
    //           return value.join()
    //         }},
    //       {key: "price", label: "Price"},
    //       {key:"status", label:"Status"},
    //     ],
    //   isfree:false,
      tkttype:"",
      tktmod:"",
      tktindex:""
    }
  },
  components: {
     DatePicker,
     UploadImage
  },
  created() {
  },
  components: { 
    DatePicker,
    UploadImage,
  },
  created() {},
  computed: {},
  methods: {
    getBannerName: utils.getBannerName,
    getLogoName: utils.getLogoName,
    to_disp_name: function (name) {
      var idx = name.indexOf("-");
      var subs = name.substring(idx + 1);
      return subs.replaceAll("-", " ");
    },
    group_add: function () {
      let vue = this;
      let ev = vue.$parent.event;
      ev.groups.forEach((item) => {
        console.log(item.dname);
      });
      window.wss_send(vx, "adm_event_add_group", {
        event: {
          id: ev.id,
        },
        group: {
          name: ev.id + "-" + vue.tier_name.replaceAll(" ", ""),
        },
      });
    },
    group_delete: function (g) {
      let vue = this;
      let ev = vue.$parent.event;
      var tierExists;
      vue.tkts.forEach((item) => {
        if (item.groups.includes(g.dname)) {
          tierExists = item.groups.includes(g.dname);
        }
      });
      if (!tierExists) {
        vue.$bvModal
          .msgBoxConfirm("Are you sure you want to delete this item?", {
            title: "Confirm delete",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Delete",
            cancelTitle: "Cancel",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              window.wss_send(vx, "adm_event_rem_group", {
                event: {
                  id: ev.id,
                },
                group: {
                  name: g.name,
                },
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    update: function () {
      let vue = this;
      let ev = vue.$parent.event;
      let has_err = false;
      vue.no_file_error = false;
      vue.file_error = false;
      ev.startep = vue.startdate.getTime();
      ev.endep = vue.enddate.getTime();

      if (!ev.startep || !ev.endep) {
        vue.$parent.toast("err", "Event must have a start and end time");
        has_err = true;
      }

      if (!ev.name) {
        vue.$parent.toast("err", "An event name is required");
        has_err = true;
      }

      if (!ev.descr) {
        vue.$parent.toast("err", "An event description is required");
        has_err = true;
      }

      ev.is_pub = vue.is_pub ? true : false;
      ev.emailsubject = "You have registered for the event " + ev.name;
      ev.emailtext = "Hello, <br><br>Join us";
      ev.coord = {};
      vue.coord_list.forEach(function (em) {
        ev.coord[em.toLowerCase()] = {};
      });

      if (has_err) {
        return;
      }
      vue.isSubmitDisabled = true;
      utils.event_modified(ev);
      ev.delta = true;
      let event = utils.local_to_remote(ev);
      delete event.sessions;

      window.wss_send(vx, "adm_event_set", { rtag: "event", event: event });
    },
    delete_event: function () {
      let vue = this;
      this.$bvModal
        .msgBoxConfirm(
          "Do you really want to delete the Event (including stages/sessions etc)?"
        )
        .then((value) => {
          if (!value) return;
          // delete the attendees
          window.wss_send(vx, "adm_event_del", {
            event: {
              id: this.$parent.event.id,
            },
          });
        })
        .catch((err) => {
          // An error occurred
          console.log("msg box error");
        });
    },
    coord_validator: function (em) {
      return window.validate_email(em);
    },
    publicSet: function (v) {
      this.is_pub = v;
    },
    event_setup: function () {
      let vue = this;
      if (!vue.$parent.event.id) {
        return;
      }
      let groups = vue.$parent.event.groups;
      vue.startdate = new Date(vue.$parent.event.startep);
      vue.enddate = new Date(vue.$parent.event.endep);
      vue.is_pub = vue.$parent.event.is_pub;
      vue.coord_list = [];
      if (vue.$parent.event.coord) {
        Object.keys(vue.$parent.event.coord).forEach(function (k) {
          vue.coord_list.push(k.toLowerCase());
        });
      }
    },
  
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx, "updateevent");
  },
  watch: {
    "$parent.event.id": function (to, from) {
      this.event_setup();
    },
  },
  mounted() {
    let vue = this;
    vue.event_success = false;
    vue.event_setup();
    window.wss_open(vx, {
      acc: vue.$parent.acc,
      uid: vx.user.id,
      routes_id: "updateevent",
      routes: {
        adm_event_set: function (msg) {
          if (msg.rtag != "event") return;
          vue.isSubmitDisabled = false;
          if (msg.data.error) {
            console.log(msg.data.error);
            vue.$parent.toast("err", "The event updated failed");
            return;
          }
          // Whether new or updated the full event record is returned.
          let e = msg.data.event;
          vue.$parent.toast("ok", "The event has been updated");

          //update local event version
          vue.$parent.event.id = e.id;
          vue.$parent.event.ver = e.ver;
          vue.$parent.event.pver = e.ver;

          /* Always add freeaccess. */
          window.wss_send(vx, "adm_event_add_group", {
            event: {
              id: e.id,
            },
            group: {
              name: e.id + "-freeaccess",
              is_free: true,
            },
          });
        },
        adm_event_del: function (msg) {
          if (msg.data.error) {
            console.log(msg.data.error);
          } else {
            vue.$bvModal
              .msgBoxOk("This event has been deleted")
              .then((value) => {
                vue.$router.push({ name: "eventmanager" });
              });
          }
        },
        adm_event_rem_group: function (msg) {
          if (msg.data.error) {
            console.log(msg.data.error);
            return;
          }
          utils.set_groups(vue.$parent.event, msg.data.event.groups);
          return;
        },
        adm_event_add_group: function (msg) {
          vue.tier_name = "";
          if (msg.data.error) {
            console.log(msg.data.error);
            return;
          }
          utils.set_groups(vue.$parent.event, msg.data.event.groups);
          return;
        },
      },
    });
  },
};
</script> 
<style>
.row {
  padding-top: 10px;
}
.error {
  color: red;
  padding-top: 10px;
  font-weight: 500;
}
.message {
  font-weight: 500;
  color: red;
  padding-top: 5px;
}
.para {
  white-space: pre-wrap;
}
</style>
